import React, { useState, useEffect } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import Tooltip from "@mui/material/Tooltip";
import "./BacktoTop.css";

function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  //--------------------------------------------------------------------------------
  //Scroll to top function to make the scroll to top
  //--------------------------------------------------------------------------------
  const handleScroll = () => {
    if (window.scrollY > 10) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  //--------------------------------------------------------------------------------
  //Based on the scroll useeffet will call this function
  //--------------------------------------------------------------------------------
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  //--------------------------------------------------------------------------------
  //Useeffect to the observe the scroll
  //--------------------------------------------------------------------------------
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`scroll-to-top ${isVisible ? "visible" : ""}`}
      onClick={scrollToTop}
    >
      <Tooltip title="Scroll to top" arrow placement="left">
        <ArrowUpwardIcon className="scroll-icon" />
      </Tooltip>
    </div>
  );
}

export default BackToTop;
